import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';

import { login } from '../../../redux/ducks/auth';
import { isAuthenticated } from '../../../redux/selectors/auth';

import pageWrapper from '../../containers/AnonPage';
import AuthBox from '../../containers/AuthBox';
import Button from '../../common/Button';
import FormFeedback from '../../common/form/FormFeedback';
import TextInput from '../../common/form/TextInput';

import './SignIn.css';
import FormResult from '../../../FormResult';

const yup = require('yup');

const validationSchema = yup.object().shape({
  email: yup
    .string()
    .email("That doesn't look like an email address")
    .required('Email is required'),
  password: yup
    .string()
    .required('Password required')
    .min(8, 'All passwords are at least 8 characters'),
});

class SignInPage extends React.PureComponent {
  render() {
    if (this.props.isAuthenticated) {
      const { from } = this.props.location.state || { from: { pathname: '/' } };
      return <Redirect to={from} />;
    }

    return (
      <AuthBox>
        <h2>Sign In</h2>

        <Formik
          initialValues={{
            email: '',
            password: '',
          }}
          onSubmit={({ email, password }, { setSubmitting, setStatus }) => {
            const onSuccess = () => {};
            const onFailure = (status) => {
              setSubmitting(false);
              setStatus(new FormResult(status));
            };

            this.props.doLogin(email, password, onSuccess, onFailure);
          }}
          validationSchema={validationSchema}
          render={({
            // values,
            // errors,
            // touched,
            status,
            // handleChange,
            // handleBlur,
            handleSubmit,
            // isSubmitting,
          }) => (
            <Form>
              <FormFeedback status={status} />

              <Field
                name="email"
                label="Email"
                placeholder=""
                type="email"
                required
                autoComplete="username"
                component={TextInput}
              />

              <Field
                name="password"
                label="Password"
                type="password"
                required
                autoComplete="current-password"
                component={TextInput}
              />
              <p className="signin-forgotLink">
                <Link to="/forgot-password">Forgot password?</Link>
              </p>

              <Button
                type="submit"
                label="Sign in"
                isActive={this.props.isSigningIn}
                color="primary"
                size="large"
                className="signin-button"
                isFullWidth
                handler={handleSubmit}
              />
            </Form>
          )}
        />

        {/* <p className="signin-signUpLink">
          Not a member? <Link to="/sign-up">Sign up now</Link>
          </p> */}
      </AuthBox>
    );
  }
}

SignInPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isSigningIn: PropTypes.bool.isRequired,
  doLogin: PropTypes.func.isRequired,
  location: PropTypes.shape({ state: PropTypes.object }),
};

SignInPage.defaultProps = {
  location: {},
};

function mapStateToProps(state) {
  return {
    isAuthenticated: isAuthenticated(state),
    isSigningIn: state.auth.isSigningIn,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    doLogin: (email, password, onSuccess, onFailure) => {
      dispatch(login(email, password, onSuccess, onFailure));
    },
  };
}

export default pageWrapper(connect(mapStateToProps, mapDispatchToProps)(SignInPage));



// WEBPACK FOOTER //
// ./src/components/pages/anon/SignIn.jsx